// extracted by mini-css-extract-plugin
module.exports = {"ccpa-modal":"modalCCPA_ccpa-modal__0mPQ_"};